import { DISPLAY_TZ } from "./lib/tz";

// Build-time configuration. Vite inlines VITE_* values; there are no secrets in the browser bundle.
const apiUrl = import.meta.env.VITE_API_URL as string | undefined;
if (!apiUrl) throw new Error("VITE_API_URL is not set");

export const API_URL = apiUrl.replace(/\/$/, "");

export { DISPLAY_TZ };

export const formatDateTime = (iso: string) =>
  new Intl.DateTimeFormat("en-ZA", { dateStyle: "medium", timeStyle: "short", timeZone: DISPLAY_TZ }).format(new Date(iso));
